(function () {
	$('#loginForm.loginFormMenue input').on('change', function () {
		$(this).removeClass('is-invalid');
	});

	const login = new JJK.Login('LoginButton');

	$('#EmailLogin').on('keydown', function (e) {
		if (e.which === 13) {
			e.preventDefault();
			login.Submit();
		}
	});
})();
